import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function LoyaltyCard() {
  const { user } = useAuth();
  const points = user?.loyalty_points ?? user?.punti_fedelta ?? 0;

  return (
    <div className="negozi-container">
      <h2 className="yellow title">Carta Fedeltà</h2>
      {user ? (
        <div>
          <p>
            <strong>Punti fedeltà:</strong> {points}
          </p>
        </div>
      ) : (
        <p>
          Devi <Link to="/login">accedere</Link> per vedere la tua Carta Fedeltà.
        </p>
      )}
    </div>
  );
}